import { render, staticRenderFns } from "./AppDisplay.vue?vue&type=template&id=a51be01c&"
import script from "./AppDisplay.vue?vue&type=script&lang=js&"
export * from "./AppDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a51be01c')) {
      api.createRecord('a51be01c', component.options)
    } else {
      api.reload('a51be01c', component.options)
    }
    module.hot.accept("./AppDisplay.vue?vue&type=template&id=a51be01c&", function () {
      api.rerender('a51be01c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/AppDisplay.vue"
export default component.exports